module.exports = __webpack_public_path__ + "img/title-3.4fb53bcd.png";